// No-op replacement for bundled extensions that cannot function in the web
// build at all (e.g. installer_dotnet, which probes the OS for a .NET
// runtime and reports an unrecoverable error when it can't).
function init(_context) {
    return true;
}

module.exports = init;
module.exports.default = init;
